import { render, staticRenderFns } from "./foodDetails.vue?vue&type=template&id=64675e68&scoped=true&"
import script from "./foodDetails.vue?vue&type=script&lang=js&"
export * from "./foodDetails.vue?vue&type=script&lang=js&"
import style0 from "./foodDetails.vue?vue&type=style&index=0&id=64675e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64675e68",
  null
  
)

export default component.exports